<template>
  <div class="kpt-zone-action">
    <strong>IF REMOTES</strong> <b-tag type="is-success">{{action.presence}}</b-tag> <strong>THEN</strong> <b-tag type="is-primary">{{action.actionType}}</b-tag>
  </div>
</template>
<script>
export default {
  props: {
    action: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/_colors';
.kpt-zone-action {
  padding: 12px;
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: 90px 80px 40px 80px;
  grid-gap: 15px;
  border-bottom: 1px solid $grey-lighter;

  &:last-child {
    border-bottom: 0;
  }

  &:nth-child(odd) {
    background: $white-ter;
  }
}
</style>
